/* Auto-generated. Do not edit. */

export { default as About } from './About';
export { default as Ads } from './Ads';
export { default as Alerts } from './Alerts';
export { default as App } from './App';
export { default as Appointment } from './Appointment';
export { default as Banner } from './Banner';
export { default as Blogs } from './Blogs';
export { default as Breadcrumb } from './Breadcrumb';
export { default as CallToAction } from './CallToAction';
export { default as Centers } from './Centers';
export { default as ChooseUs } from './ChooseUs';
export { default as Comments } from './Comments';
export { default as Commodities } from './Commodities';
export { default as ContactUs } from './ContactUs';
export { default as Content } from './Content';
export { default as DemoSiteTemplates } from './DemoSiteTemplates';
export { default as Departments } from './Departments';
export { default as Doctors } from './Doctors';
export { default as Faq } from './Faq';
export { default as Features } from './Features';
export { default as Footer } from './Footer';
export { default as Gallery } from './Gallery';
export { default as Header } from './Header';
export { default as Headline } from './Headline';
export { default as Health } from './Health';
export { default as Help } from './Help';
export { default as Hero } from './Hero';
export { default as Holidays } from './Holidays';
export { default as Info } from './Info';
export { default as Insurances } from './Insurances';
export { default as List } from './List';
export { default as Map } from './Map';
export { default as Mission } from './Mission';
export { default as Newsletter } from './Newsletter';
export { default as Offer } from './Offer';
export { default as OurServices } from './OurServices';
export { default as Packages } from './Packages';
export { default as Partners } from './Partners';
export { default as ServiceSlider } from './ServiceSlider';
export { default as Shipping } from './Shipping';
export { default as Statistics } from './Statistics';
export { default as Support } from './Support';
export { default as Technology } from './Technology';
export { default as Test } from './Test';
export { default as Video } from './Video';
export { default as Why } from './Why';
export { default as WhyChooseUs } from './WhyChooseUs';
export { default as Work } from './Work';
export { default as WorkTimes } from './WorkTimes';
export { default as Yoga } from './Yoga';
